import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";

import StorefrontLayout from "@/components/storefront/StorefrontLayout";
import Home from "@/pages/storefront/Home";
import Shop from "@/pages/storefront/Shop";
import ProductDetail from "@/pages/storefront/ProductDetail";
import Cart from "@/pages/storefront/Cart";
import Checkout from "@/pages/storefront/Checkout";
import OrderSuccess from "@/pages/storefront/OrderSuccess";
import OrderTracking from "@/pages/storefront/OrderTracking";
import Contact from "@/pages/storefront/Contact";
import Policy from "@/pages/storefront/Policy";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminProductForm from "@/pages/admin/ProductForm";
import AdminCategories from "@/pages/admin/Categories";
import AdminBrands from "@/pages/admin/Brands";
import AdminOrders from "@/pages/admin/Orders";
import AdminOrderDetail from "@/pages/admin/OrderDetail";
import AdminCustomers from "@/pages/admin/Customers";
import AdminShipping from "@/pages/admin/Shipping";
import AdminSettings from "@/pages/admin/Settings";
import AdminInstagram from "@/pages/admin/Instagram";
import AdminDiscounts from "@/pages/admin/Discounts";
import AdminMaintenance from "@/pages/admin/Maintenance";
import CatalogShippingAudit from "@/pages/admin/CatalogShippingAudit";

export default function App() {
    return (
        <SettingsProvider>
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Toaster
                            theme="dark"
                            richColors
                            position="top-right"
                            toastOptions={{
                                style: {
                                    background: "#121214",
                                    border: "1px solid #27272A",
                                    color: "white",
                                    fontFamily: "Barlow, sans-serif",
                                },
                            }}
                        />
                        <Routes>
                            {/* Storefront */}
                            <Route element={<StorefrontLayout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/product/:slug" element={<ProductDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/order-success" element={<OrderSuccess />} />
                                <Route path="/track-order" element={<OrderTracking />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/policy/:slug" element={<Policy />} />
                                <Route path="/policy/:slug/:sub" element={<Policy />} />
                            </Route>

                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<AdminDashboard />} />
                                <Route path="products" element={<AdminProducts />} />
                                <Route path="products/new" element={<AdminProductForm />} />
                                <Route path="products/:id" element={<AdminProductForm />} />
                                <Route path="categories" element={<AdminCategories />} />
                                <Route path="brands" element={<AdminBrands />} />
                                <Route path="orders" element={<AdminOrders />} />
                                <Route path="orders/:id" element={<AdminOrderDetail />} />
                                <Route path="customers" element={<AdminCustomers />} />
                                <Route path="shipping" element={<AdminShipping />} />
                                <Route path="settings" element={<AdminSettings />} />
                                <Route path="instagram" element={<AdminInstagram />} />
                                <Route path="discounts" element={<AdminDiscounts />} />
                                <Route path="maintenance" element={<AdminMaintenance />} />
                                <Route path="catalog/shipping-audit" element={<CatalogShippingAudit />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </SettingsProvider>
    );
}
